// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__26tZN","label":"style_label__22lgh"};